import { render, staticRenderFns } from "./BasicContent.vue?vue&type=template&id=282f831a&scoped=true&"
import script from "./BasicContent.vue?vue&type=script&lang=js&"
export * from "./BasicContent.vue?vue&type=script&lang=js&"
import style0 from "./BasicContent.vue?vue&type=style&index=0&id=282f831a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282f831a",
  null
  
)

export default component.exports